import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Card from '../Card/Card';
import TableHead from './TableHead';
import TableBody from './TableBody';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var tableStyles = /*#__PURE__*/css("border-spacing:0;width:100%;th,tr{display:flex;}th{color:", theme.colors.shade60, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RhYmxlL1RhYmxlLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTdUIiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGFibGUvVGFibGUuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBDYXJkIGZyb20gJy4uL0NhcmQvQ2FyZCdcblxuaW1wb3J0IFRhYmxlSGVhZCBmcm9tICcuL1RhYmxlSGVhZCdcbmltcG9ydCBUYWJsZUJvZHkgZnJvbSAnLi9UYWJsZUJvZHknXG5pbXBvcnQgeyBlbG8gYXMgdGhlbWUgfSBmcm9tICcuLi8uLi90aGVtZXMnXG5cbmNvbnN0IHRhYmxlU3R5bGVzID0gY3NzYFxuICBib3JkZXItc3BhY2luZzogMDtcbiAgd2lkdGg6IDEwMCU7XG5cbiAgdGgsXG4gIHRyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICB9XG5cbiAgdGgge1xuICAgIGNvbG9yOiAke3RoZW1lLmNvbG9ycy5zaGFkZTYwfTtcbiAgfVxuYFxuXG5jb25zdCBUYWJsZSA9ICh7IGhlYWRlcnMsIGRhdGEsIGRhdGFUZXN0SWQsIHBvc2l0aW9uLCBlbGxpcHNpcywgbWF4TGluZXMgfSkgPT4gKFxuICA8Q2FyZD5cbiAgICA8dGFibGUgY3NzPXt0YWJsZVN0eWxlc30gZGF0YS10ZXN0LWlkPXtkYXRhVGVzdElkfT5cbiAgICAgIDxUYWJsZUhlYWQgaGVhZGVycz17aGVhZGVyc30gZGF0YVRlc3RJZD17ZGF0YVRlc3RJZH0gLz5cblxuICAgICAge2hlYWRlcnMgJiYgKFxuICAgICAgICA8VGFibGVCb2R5XG4gICAgICAgICAgZGF0YT17ZGF0YX1cbiAgICAgICAgICBoZWFkZXJzPXtoZWFkZXJzfVxuICAgICAgICAgIHBvc2l0aW9uPXtwb3NpdGlvbn1cbiAgICAgICAgICBlbGxpcHNpcz17ZWxsaXBzaXN9XG4gICAgICAgICAgbWF4TGluZXM9e21heExpbmVzfVxuICAgICAgICAgIGRhdGFUZXN0SWQ9e2RhdGFUZXN0SWR9XG4gICAgICAgIC8+XG4gICAgICApfVxuICAgIDwvdGFibGU+XG4gIDwvQ2FyZD5cbilcblxuY29uc3QgaGVhZGVyUHJvcHNUeXBlcyA9IFByb3BUeXBlcy5zaGFwZSh7XG4gIGlkOiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG4gIHZhbHVlOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIG9uQ2xpY2s6IFByb3BUeXBlcy5mdW5jLFxuICB3aWR0aDogUHJvcFR5cGVzLm51bWJlcixcbn0pXG5cbmNvbnN0IGNlbGxQcm9wVHlwZXMgPSBQcm9wVHlwZXMuc2hhcGUoe1xuICBpZDogUHJvcFR5cGVzLm51bWJlci5pc1JlcXVpcmVkLFxuICB2YWx1ZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgb25DbGljazogUHJvcFR5cGVzLmZ1bmMsXG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMuZWxlbWVudCxcbn0pXG5cbmNvbnN0IG1lbnVQcm9wVHlwZXMgPSBQcm9wVHlwZXMuc2hhcGUoe1xuICBpZDogUHJvcFR5cGVzLm51bWJlci5pc1JlcXVpcmVkLFxuICB2YWx1ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBvbkNsaWNrOiBQcm9wVHlwZXMuZnVuYyxcbn0pXG5cblRhYmxlLnByb3BUeXBlcyA9IHtcbiAgaGVhZGVyczogUHJvcFR5cGVzLmFycmF5T2YoaGVhZGVyUHJvcHNUeXBlcykuaXNSZXF1aXJlZCxcbiAgZGF0YTogUHJvcFR5cGVzLmFycmF5T2YoXG4gICAgUHJvcFR5cGVzLnNoYXBlKHtcbiAgICAgIGNlbGxzOiBQcm9wVHlwZXMuYXJyYXlPZihjZWxsUHJvcFR5cGVzKS5pc1JlcXVpcmVkLFxuICAgICAgbWVudTogUHJvcFR5cGVzLmFycmF5T2YobWVudVByb3BUeXBlcyksXG4gICAgfSkuaXNSZXF1aXJlZCxcbiAgKS5pc1JlcXVpcmVkLFxuICBkYXRhVGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBwb3NpdGlvbjogUHJvcFR5cGVzLm9uZU9mKFsnbGVmdCcsICdyaWdodCddKSxcbiAgZWxsaXBzaXM6IFByb3BUeXBlcy5ib29sLFxuICBtYXhMaW5lczogUHJvcFR5cGVzLm51bWJlcixcbn1cbmV4cG9ydCBkZWZhdWx0IFRhYmxlXG4iXX0= */"));
var Table = function Table(_ref) {
  var headers = _ref.headers,
    data = _ref.data,
    dataTestId = _ref.dataTestId,
    position = _ref.position,
    ellipsis = _ref.ellipsis,
    maxLines = _ref.maxLines;
  return ___EmotionJSX(Card, null, ___EmotionJSX("table", {
    css: tableStyles,
    "data-test-id": dataTestId
  }, ___EmotionJSX(TableHead, {
    headers: headers,
    dataTestId: dataTestId
  }), headers && ___EmotionJSX(TableBody, {
    data: data,
    headers: headers,
    position: position,
    ellipsis: ellipsis,
    maxLines: maxLines,
    dataTestId: dataTestId
  })));
};
var headerPropsTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  width: PropTypes.number
});
var cellPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.element
});
var menuPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func
});
Table.propTypes = {
  headers: PropTypes.arrayOf(headerPropsTypes).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    cells: PropTypes.arrayOf(cellPropTypes).isRequired,
    menu: PropTypes.arrayOf(menuPropTypes)
  }).isRequired).isRequired,
  dataTestId: PropTypes.string,
  position: PropTypes.oneOf(['left', 'right']),
  ellipsis: PropTypes.bool,
  maxLines: PropTypes.number
};
export default Table;